import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    an_dich_vu: null, //boolean, optional // Cho biết dịch vụ có bị ẩn hay không
    da_duyet: null, //boolean, optional // Cho biết dịch vụ đã được duyệt hay chưa
    ly_do_khong_duyet: null, //string, optional // Lý do không duyệt nội dung, nếu bằng null thì nghĩa là chưa xét duyệt
    ten: { //object, optional // Tên dịch vụ du lịch
        vi: null, //string, optional // Tên tiếng Việt
        en: null, //string, optional // Tên tiếng Anh
    },
    noi_dung: { //object, optional // Nội dung bài viết giới thiệu
        vi: null, //string, optional // [Markdown] Nội dung tiếng Việt
        en: null, //string, optional // [Markdown] Nội dung tiếng Anh
    },
    dia_diem: { //object, optional // Thông tin địa điểm của tin tức
        dia_diem: null, //string, optional // Địa điểm
        province_id: null, //IdRef, optional // Mã tỉnh
        district_id: null, //IdRef, optional // Mã huyện
        lng: null, //double, //optional, min: -180, max: 180 // Kinh độ (longitude)
        lat: null, //double, //optional, min: -90, max: 90 // Vĩ độ (latitude)
    },
    anh: { //object, optional // Các thể loại ảnh của dịch vụ
        anh_dai_dien: null, //IdRef, optional // Mã ảnh đại diện của dịch vụ
        anh_bai_viet: [], //array of IdRef, optional // Danh sách ảnh của bài viết
    },
    ghim: false, //boolean, optional // Cho biết dịch vụ có được ghim hay không
    thu_tu: null, //integer, optional // Thứ tự sắp xếp (chỉ tác dụng khi ghim=true)
};

// validation form
model.validForm = {
    an_dich_vu: [], //boolean, optional // Cho biết dịch vụ có bị ẩn hay không
    da_duyet: [], //boolean, optional // Cho biết dịch vụ đã được duyệt hay chưa
    ly_do_khong_duyet: [], //string, optional // Lý do không duyệt nội dung, nếu bằng null thì nghĩa là chưa xét duyệt
    ten: { //object, optional // Tên dịch vụ du lịch
        vi: [ValidService.required], //string, optional // Tên tiếng Việt
        en: [ValidService.required], //string, optional // Tên tiếng Anh
    },
    noi_dung: { //object, optional // Nội dung bài viết giới thiệu
        vi: [], //string, optional // [Markdown] Nội dung tiếng Việt
        en: [], //string, optional // [Markdown] Nội dung tiếng Anh
    },
    dia_diem: { //object, optional // Thông tin địa điểm của tin tức
        dia_diem: [], //string, optional // Địa điểm
        province_id: [], //IdRef, optional // Mã tỉnh
        district_id: [], //IdRef, optional // Mã huyện
        lng: [], //double, //optional, min: -180, max: 180 // Kinh độ (longitude)
        lat: [], //double, //optional, min: -90, max: 90 // Vĩ độ (latitude)
    },
    anh: { //object, optional // Các thể loại ảnh của dịch vụ
        anh_dai_dien: [], //IdRef, optional // Mã ảnh đại diện của dịch vụ
        anh_bai_viet: [], //array of IdRef, optional // Danh sách ảnh của bài viết
    },
    ghim: [], //boolean, optional // Cho biết dịch vụ có được ghim hay không
    thu_tu: [], //integer, optional // Thứ tự sắp xếp (chỉ tác dụng khi ghim=true)
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
    fileUploadOption: {
        AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        },
        AnhBaiViet: {
            limit: null,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        }
    },

};

// validation các form khác
model.validFormOther = {
};

model.trangThaiDichVu = [
    {
        code: "true",
        text: "Ẩn dịch vụ"
    },
    {
        code: "false",
        text: "Hiện dịch vụ"
    }
];

model.trangThaiGhim = [
    {
        code: "true",
        text: "Ghim"
    },
    {
        code: "false",
        text: "Không Ghim"
    }
];

model.trangThaiDuyet = [
    {
        code: "true",
        text: "Đã duyệt"
    },
    {
        code: "false",
        text: "Chưa duyệt"
    }
];

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["ghim", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            "ten.vi": "",
            thoi_diem_tao: "",
            ghim: null
        },
        valid: {},
        operator: {
            "ten.vi": ":regex_i:", //:regex:, $vn_text=Viêt nam
            thoi_diem_tao: ":in_that_day:"
        }
    }
};

export default model;